import React from 'react'

const Context = React.createContext()

export function withContext(Component) {
  return function contextComponent(props) {
    return (
      <Context.Consumer>
        {context => <Component {...props} context={context} />}
      </Context.Consumer>
    )
  }
}

export default Context



// WEBPACK FOOTER //
// ./src/context/index.js